import React, { useMemo } from "react";
import BaseChart from "../../components/ui/BaseChart";

const MonthlyCompletionChart = ({ data }) => {
  const chartOptions = useMemo(() => {
    if (!data?.length) return null;
    const categories = data.map((d) => d.month);
    const totals = data.map((d) => d.total);
    const completed = data.map((d) => d.completed);
    const rates = data.map((d) => d.rate);

    return {
      chart: {
        height: 360,
        // Use spacing (outer padding) instead of a fixed margin so Highcharts
        // reserves room for both y-axis labels (incl. the right "%" axis) and
        // the bottom legend — a fixed margin clips/crowds those labels.
        spacing: [12, 12, 8, 8],
        backgroundColor: "transparent",
        style: { fontFamily: "Poppins, sans-serif" },
      },
      title: { text: null },
      xAxis: {
        categories,
        lineColor: "#e5e7eb",
        tickLength: 0,
        labels: { style: { fontSize: "10px", color: "#9ca3af" } },
        crosshair: { color: "#f1f5f9" },
      },
      yAxis: [
        {
          title: { text: null },
          gridLineColor: "#f3f4f6",
          labels: { style: { fontSize: "10px", color: "#9ca3af" } },
          min: 0,
        },
        {
          title: { text: null },
          opposite: true,
          min: 0,
          max: 100,
          labels: {
            format: "{value}%",
            style: { fontSize: "10px", color: "#9ca3af" },
          },
          gridLineWidth: 0,
        },
      ],
      legend: {
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal",
        // Non-floating so the legend reserves its own row BELOW the x-axis
        // month labels instead of being drawn on top of them.
        floating: false,
        margin: 26,
        padding: 2,
        itemStyle: { fontSize: "10px", fontWeight: "normal", color: "#555" },
        symbolRadius: 3,
        symbolHeight: 8,
      },
      tooltip: {
        shared: true,
        backgroundColor: "#1e293b",
        style: { color: "#f8fafc" },
        borderWidth: 0,
        borderRadius: 6,
        formatter() {
          const pts = this.points ?? [];
          const lines = pts.map((p) =>
            p.series.type === "spline"
              ? `<span style="color:${p.color}">●</span> ${p.series.name}: <b>${p.y}%</b>`
              : `<span style="color:${p.color}">●</span> ${p.series.name}: <b>${p.y}</b>`,
          );
          return `<b>${this.x}</b><br/>${lines.join("<br/>")}`;
        },
      },
      plotOptions: {
        column: { borderRadius: 4, borderWidth: 0, groupPadding: 0.1 },
        spline: { marker: { radius: 3, symbol: "circle" }, lineWidth: 2.5 },
      },
      series: [
        {
          type: "column",
          name: "Total WOs",
          data: totals,
          color: "#DBEAFE",
          yAxis: 0,
        },
        {
          type: "column",
          name: "Completed",
          data: completed,
          color: "#0F40AE",
          yAxis: 0,
        },
        {
          type: "spline",
          name: "Completion Rate",
          data: rates,
          color: "#FF5F00",
          yAxis: 1,
          tooltip: { valueSuffix: "%" },
          marker: { fillColor: "#FF5F00" },
          zIndex: 5,
        },
      ],
    };
  }, [data]);

  if (!chartOptions) return null;

  return <BaseChart options={chartOptions} className="w-full" />;
};

export default MonthlyCompletionChart;
